import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, ListTree, FileText, FileSearch, Settings } from 'lucide-react';

const ITEMS = [
  { to: '/dashboard', label: 'Dash', ariaLabel: 'Dashboard', end: true, Icon: LayoutDashboard },
  { to: '/graph', label: 'Flow', ariaLabel: 'Exception Flow Map', Icon: ListTree },
  { to: '/reports', label: 'Reports', ariaLabel: 'Reports', Icon: FileText },
  { to: '/search', label: 'Logs', ariaLabel: 'Exception Logs', Icon: FileSearch },
  { to: '/settings', label: 'Settings', ariaLabel: 'Settings', Icon: Settings },
];

/**
 * Bottom navigation for small viewports when AppShell chrome is active.
 */
export default function AppShellMobileNav() {
  return (
    <nav className="app-shell-mobile-nav" aria-label="Primary navigation">
      {ITEMS.map(({ to, label, ariaLabel, end, Icon }) => (
        <NavLink key={to} to={to} end={end} aria-label={ariaLabel}>
          {({ isActive }) => (
            <>
              <Icon size={20} strokeWidth={2} aria-hidden="true" />
              <span>{label}</span>
              {isActive ? <span className="app-shell-mobile-nav__pip" aria-hidden="true" /> : null}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
